import type { FaireReviewEntity } from "../../entity_types/review";

// Real brand-level review for Lemonade Shoes, read off their public Faire
// reviews list (Ryan, 2026-08-17) — verbatim comment, real reviewer, real
// rating. The longest of the three; useful for checking the spotlight module
// still reads when the quote runs past a couple of lines.
export const review_ls7: FaireReviewEntity = {
  token: "review_ls7",
  type: "review",
  brandName: "Lemonade Shoes",
  brandToken: "b_mz3xxxsvnf",
  reviewType: "brand",
  reviewerName: "Tajzsa",
  reviewerLocation: "McDonough, GA",
  stars: 5,
  reviewText:
    "I have received my orders very fast and my merchandise is exactly as shown. Great quality items which I love. Customer service is excellent and I will be ordering more from them.",
  reviewDate: "Feb 21, 2025",
  meta: {
    source: "api",
    importedAt: "2026-08-17T00:00:00.000Z",
    importedBy: "entity-db-cli",
  },
};
